import {
    renderEditorActionTag
} from "v4/components/form/Field/components/InputRichText/plugins/ActionTag/utils/actionTagUtils";

export default function initActionTagShow(container, tags = []) {
    container
        .querySelectorAll('[data-role="editor-action-tag"]')
        .forEach(editorActionTag => {
            const tagInfos = tags.find(tag => tag.id === editorActionTag.dataset.tagId) ?? {};
            renderEditorActionTag(editorActionTag, tagInfos, true)
        });
}
